import React from 'react';
import SalaryCalculator from './components/SalaryCalculator';
import './App.css';

function App() {
  return (
    <div className="App">
      <SalaryCalculator />
    </div>
  );
}

export default App;